<template>
    <form method="post" class="grid grid-cols-12 gap-6 px-2" @submit.prevent="saveForm">
        <div v-if="loading" class="absolute z-100 left-0 top-0 w-full h-full flex items-center justify-center">
            <Preloader />
        </div>
        <div class="relative col-span-12">
            <label for="form-title" class="form-label">
                Название
                <sup v-if="v$.form.title.required" class="text-theme-6">*</sup>
            </label>
            <label v-if="v$.form.title.$errors.length" for="form-title" class="form-input-text-error">
                {{ getOverrideMessage(v$.form.title.$errors[0].$message) }}
            </label>
            <input
                id="form-title"
                v-model="form.title"
                type="text"
                class="form-control"
                :class="{ 'form-input-error': v$.form.title.$errors.length }"
                autocomplete="off"
            />
        </div>

        <div class="relative col-span-12">
            <label for="form-title" class="form-label"> ID палубы на сайте тур.оператора </label>
            <input id="form-title" v-model="form.idDeck" type="text" class="form-control" autocomplete="off" />
        </div>

        <div class="col-span-12">
            <label for="index" class="form-label">Сортировка</label>
            <input id="index" v-model="form.index" type="number" max="100" class="form-control" />
        </div>

        <div class="col-span-12">
            <label for="index" class="form-label">Схема <sup>*</sup></label>
            <UploadImageNew v-model="form.scheme_url" />
        </div>

        <div class="col-span-12">
            <label for="index" class="form-label">Схема в svg</label>
            <UploadImageNew v-model="form.svg_scheme" :accept-extensions="image / svg + xml">
                <template #text="">
                    <span class="btn btn-primary inline-block">Загрузите svg схему</span>
                </template>
            </UploadImageNew>
        </div>

        <div class="col-span-12 flex justify-end">
            <button type="button" class="btn btn-secondary mr-2 w-24" @click.prevent="$emit('dataSaved')">
                Отмена
            </button>
            <button type="submit" class="btn btn-primary">Сохранить</button>
        </div>
    </form>
</template>

<script>
import { errorResponse } from '@/mixins/form/form-mixin';
import UploadImageNew from '@/components/upload-image/UploadImageNew';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import Preloader from '@/components/preloader/Main';
import { helper as $h } from '@/utils/helper';
import { formPreparation } from '@/utils/object-to-form-data';

export default {
    name: 'CreateDeck',
    components: { UploadImageNew, Preloader },
    mixins: [errorResponse],
    emits: ['dataSaved'],

    setup() {
        return { v$: useVuelidate() };
    },
    validations() {
        return {
            form: {
                title: { required },
            },
        };
    },
    data() {
        return {
            loading: false,
            form: {
                title: null,
                weight: 0,
                scheme: null,
                scheme_url_delete: null,
                svg_scheme: null,
                svg_scheme_delete: null,
                idDeck: null,
            },
        };
    },
    methods: {
        async saveForm() {
            const isFormCorrect = await this.v$.$validate();

            if (!isFormCorrect) {
                this.$notify({ text: 'Заполните все поля правильно', type: 'error' });
                return;
            }

            const form = formPreparation(this.form, { imagesAsObject: true });

            this.axios
                .post(`ships/${this.$route.params.id}/decks`, form)
                .then((data) => {
                    this.$emit('dataSaved', true);
                })
                .catch((ex) => {
                    this.errorResponse(ex);
                });
        },
        getOverrideMessage(message) {
            return $h.getOverrideMessage(message);
        },
    },
};
</script>

<style scoped>
.form-label {
    font-weight: 700;
}
</style>
